// extracted by mini-css-extract-plugin
export default {"nameColumn":"bDggnW0vVdF3K2IZu0TH__nameColumn___","buyerName":"SyNaRmCwLwNJdTuF2JVR__buyerName___","titleLink":"NYeaLA1TThNWlPESSkgW__titleLink___"};